const filterMap = new Map([
  ["drop-shadow", "0px 0px 0px rgba(0,0,0,0)"],
  ["hue-rotate", "0deg"],
  ["blur", "0px"],
  ["brightness", "100%"],
  ["contrast", "100%"],
  ["grayscale", "0%"],
  ["invert", "0%"],
  ["opacity", "100%"],
  ["saturate", "100%"],
  ["sepia", "0%"],
  ["url", ""],
]);

export const G_initials = new Map([
  [
    "transform",
    new Map([
      ["matrix", "1,0,0,1,0,0"],
      ["matrix3d", "1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1"],
      ["perspective", "0px"],
      ["translate", "0px"],
      ["translateX", "0px"],
      ["translateY", "0px"],
      ["translateZ", "0px"],
      ["translate3d", "0px,0px,0px"],
      ["scale", "1"],
      ["scaleX", "1"],
      ["scaleY", "1"],
      ["scaleZ", "1"],
      ["scale3d", "1,1,1"],
      ["rotate", "0deg"],
      ["rotateX", "0deg"],
      ["rotateY", "0deg"],
      ["rotateZ", "0deg"],
      ["rotate3d", "1,1,1,0deg"],
      ["skew", "0deg"],
      ["skewX", "0deg"],
      ["skewY", "0deg"],
    ]),
  ],
  ["filter", filterMap],
  ["backdrop-filter", filterMap],
  ["other", new Map([["box-shadow", "0px 0px 0px 0px rgba(0,0,0,0)"]])],
]);
